
import { Component, Vue, Prop, Watch, Emit, Mixins } from 'vue-property-decorator'
import LazyImg from '@xt/www/components/lazyImg/index.vue'
import { Observer } from 'mobx-vue'
import { MixinsHomeClick } from '@xt/client/mixins/home'
import type { ClickEvent } from '@xt/client/types/home'

@Observer
@Component({
  components: {
    LazyImg
  }
})
export default class SingleCourse extends Mixins(MixinsHomeClick) {
  @Prop({ default: () => [] }) readonly dataSource!: Array<{
    cover: string
    message: string
    event?: ClickEvent
  }>

  handleView(e: MouseEvent, url: string) {
    e.stopPropagation()

    this.$showViewer(url)
  }

  handleClick(item: { event?: ClickEvent }) {
    if (item.event) {
      this.onClickEvent(item.event)
      return
    }
  }

  created(): void {}

  mounted(): void {}

  updated(): void {}

  destroyed(): void {}
}
